/* eslint-disable */
import { Grid, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { getArmazonAnteojoSol, getCristalBlock } from "../../services/ArticuloService";
import Message from "../../utils/Message";

const initialData = {
  tipoArticulo: "",
  descripcionArticulo: "",
  label: "",
};
//
// ###########################################################################
//
const DatosArticulo = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState({});
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosArmAsol = async () => {
      let _params = {
        id_articulo: props.idArticulo,
        valida_existencia: "N",
      };
      const response = await getArmazonAnteojoSol(_params);

      if (response.ok) {
        let _response = response.data.data[0];
        let _armazonAsol =
          _response.codigo +
          " - " +
          _response.descripcion +
          " - " +
          _response.descripcion_ar_as_marca +
          " - " +
          _response.modelo;

        setData({
          ...data,
          tipoArticulo:
            (props.tipoArticulo === "armazon" ? "Armazón" : "Anteojo de Sol") + " actual",
          descripcionArticulo: _armazonAsol,
          label: "Código - Descripción - Marca - Modelo",
        });
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    const loadDatosCristalBlock = async () => {
      let _params = {
        id: props.idArticulo,
        valida_existencia: "N",
      };
      const response = await getCristalBlock(_params);

      if (response.ok) {
        let _response = response.data.data[0];
        let _cristalBlock =
          _response.codigo + " - " + _response.descripcion + " - " + _response.modelo;

        setData({
          ...data,
          tipoArticulo:
            (props.tipoArticulo === "cristal-block-od"
              ? "Cristal/Block de OD"
              : "Cristal/Block de OI") + " actual",
          descripcionArticulo: _cristalBlock,
          label: "Código - Descripción - Modelo",
        });
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    if (props.tipoArticulo === "armazon" || props.tipoArticulo === "anteojo_sol") {
      loadDatosArmAsol();
    } else if (
      props.tipoArticulo === "cristal-block-od" ||
      props.tipoArticulo === "cristal-block-oi"
    ) {
      loadDatosCristalBlock();
    } else {
      setData({
        ...data,
        tipoArticulo: "Montura del Cliente actual",
        descripcionArticulo: "CLIENTE DEJO SU ANTEOJO",
      });
    }
  }, []);
  //
  // ################################################################################
  //
  return (
    <>
      {data && (
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h6" gutterBottom>
              {data.tipoArticulo}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              id="articulo"
              label={data.label}
              size="small"
              sx={{ width: "100%" }}
              inputProps={{ style: { textAlign: "left" }, readOnly: true }}
              name="articulo"
              value={data.descripcionArticulo ?? ""}
            />
          </Grid>
        </Grid>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosArticulo;
